<template>
  <div class="input-singBox" :class="{'show-txt-rest':readonly}">
    <el-popover placement="bottom" width="276" v-model="visible" :disabled="readonly" trigger="manual" ref="popover">
      <!-- 列表 -->
      <div slot="reference" v-if="onlyValue" :class="{'show-txt-rest':readonly,'blur-border': visible,'visible-onlyValue': Boolean(currentData)}" class="table-select-box" @click="visible = !visible">
        <div class="table-select-onlyValue" v-if="currentData">
          <div class="checkbox-item table-set-color" >
            <div>
              <span>{{currentData}}</span>
            </div>
              <i  v-if="!readonly && visible" class="icon iconfont iconicon_close1 del-icon" @click.stop="checkEmpty"></i>
          </div>
        </div>
        <p v-else class="table-select-button">
          <span v-if="readonly">-</span>
          <span v-else><i class="el-icon-circle-plus"></i>添加</span>
        </p>
      </div>
      <div v-else slot="reference" :class="{'show-txt-rest':readonly}" @click="visible = !visible">
        <div class="only-value" v-if="currentData && currentData">
          <div class="checkbox-item" :class="{'readonly-item': readonly}">
            <toolTip :title="currentData" :maxWidth="'160px'">{{currentData}}</toolTip>
            <i  v-if="!readonly" class="icon iconfont iconicon_close1 del-icon" @click.stop="checkEmpty"></i>
          </div>
        </div>
        <span class="add-txt" v-else>{{readonly ? '-' : '添加'}}</span>
      </div>

      <div class="singleBox-list">
        <div class="singleBox-list-search">
          <el-input v-model="searchInput" placeholder="搜索" prefix-icon="el-input__icon icon iconfont iconicon_search1"></el-input>
        </div>
        <div class="singleBox-list-content">
          <div v-show="cList.length > 0" class="singleBox-list-item" style="display: flex;align-items: center;" @click="checkEmpty()">
            <span class="singleBox-list-item-no">无</span>
          </div>
          <div class="singleBox-list-item" v-for="(item, index) in cList" :key="index" :class="{'active': item === currentData}" @click="check(item)">
            <toolTip :maxWidth="'80%'" class="singleBox-color" :title="item">{{item}}</toolTip>
            <i v-if="item === currentData" class="icon iconfont iconicon_selected_more_task"></i>
          </div>
          <nothing v-if="cList.length === 0" width="88px" :config="{ tip: '暂无搜索结果', btnText: '', type: 'img_search' }"></nothing>
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  props: ['config', 'value', 'onlyValue', 'defaultValue', 'readonly', 'isTemplate'],
  data() {
    return {
      date: '',
      dataset: '',
      tempShow: false,
      visible: false,
      searchInput: '',
    }
  },
  computed: {
    cList() {
      if (this.searchInput === '') {
        return this.config.default_value_range;
      }
      return this.config.default_value_range.filter(item => {
        return item.indexOf(this.searchInput) != -1
      });
    },
    currentData: {
      get: function () {
        return this.value && this.value.length > 0 ?  this.value : ''
      },
      set: function (newValue) {
        this.$emit('input', newValue || '')
      }
    },
  },
  mounted() {
    document.addEventListener("click", this.bodyCloseMenus);
    if(this.isTemplate) {
      if(this.defaultValue) {
        this.$emit("input", this.defaultValue)
        this.dataset = this.defaultValue
      } else if (this.config.default_value) {
        this.$emit('input', this.config.default_value)
        this.dataset = this.config.default_value
      }
    } else {
      if (this.defaultValue && this.defaultValue.length > 0) {
        let val = this.getDefaultValue(this.defaultValue)
        this.$emit('input', val)
        this.dataset = val
      } else if (this.config.default_value) {
        this.$emit('input', this.config.default_value)
        this.dataset = this.config.default_value
      }
    }
  },
  beforeDestroy() {
     document.removeEventListener("click", this.bodyCloseMenus);
  },
  methods: {
    bodyCloseMenus(e) {
      if (this.$refs.popover.$el && !this.$refs.popover.$el.contains(e.target)) {
        if (this.visible == true) {
          this.visible = false
        }
      }
    },
    getDefaultValue(val) {
      if (val && val.length > 0) {
        return val[0].component_value
      }
    },
    getMessage(res) {
      return `<span class="message-mixin-tip">将${res.field_name}修改为</span><span class="message-mixin-task">[${res.new_data || '无'}]</span>`
    },
    changeVal(val) {
      this.currentData = val
      this.$emit('change', val || {})
    },
    check(val) {
      this.changeVal(val)
      this.visible = false
    },
    checkEmpty() {
      this.changeVal('')
      if(!this.onlyValue){
        this.visible = false
      }
    }
  }
}
</script>

<style lang="scss">

.singleBox-list-item-no {
  width: 52px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  background: rgba(32,32,40,0.1);
  border-radius: 4px;
}
.input-singBox {
  display: flex;
  align-items: center;
  // margin-left: 8px;
  cursor: pointer;

  >span{
    width: 100%;
  }
  .only-value {
    display: flex;
    flex-wrap: wrap;
    max-width: 100%;
    padding-left: 8px;
  }

  .el-select {
    width: 100%;
  }
  .el-input {
    width: 100%;
  }
  .el-input__inner {
    width: 100%;
  }
  .show-txt {
    display: flex;
    align-items: center;
  }
  .checkbox-item {
    padding: 0px 8px;
    background-color: rgba(32, 32, 32, 0.08);
    color: rgba(25, 24, 67, 0.8);
    margin-right: 4px;
    border-radius: 2px;
    height: 28px;
    line-height: 28px;
    flex-shrink: 0;
    border-radius: 4px;
    box-sizing: border-box;
    // margin-bottom: 6px;
    max-width: 160px;
    display: flex;
    align-items: center;
    >div{
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    i{
      font-size: 12px;
      flex-shrink: 0;
      display: none;
      width: 28px;
      height: 100%;
      text-align: center;
      margin-left: 2px;
      &:hover{
        background-color: rgba(0,0,0,0.1);
      }
      &:active{
        background-color: rgba(0,0,0,0.06);
      }
    }
    .tool-tip-content {
      line-height: 20px;
    }
    &:hover{
      padding-right:0;
      i{
        display: inline-block;
      }
    }
    &.readonly-item {
      &:hover {
        padding-right: 8px;
      }
    }
  }
  .table-set-color{
    max-width: 100%;
    display: flex;
    i{
      flex-shrink: 0;
    }
    &:hover{
      padding-right: 8px;
    }
  }
}
.singleBox-list {
  box-sizing: border-box;
  .el-input__icon {
    line-height: 32px;
  }
  .singleBox-list-search {
    padding: 24px;
    // border-bottom: 1px solid #f1f2f4;
    border-bottom: none;
    box-sizing: border-box;
    .el-input__inner {
      background-color: #f7f8f9;
    }
  }
  .singleBox-list-content {
    min-height: 180px;
    max-height: 319px;
    overflow-x: hidden;
    position: relative;
    margin-bottom: 8px;
    .nothing-box {
      position: relative;
      top: 50%;
      transform: translate(-50% ,0);
    }
  }
  .singleBox-list-item {
    padding: 0 24px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    i {
      flex-shrink: 0;
      font-size: 16px;
      color: $color-active !important;
    }
  }
  .active {
    color: $color-active;
  }

  .singleBox-color {
    padding: 0 8px;
    color: #fff;
    border-radius: 4px;
    height: 28px;
    line-height: 28px;
    display: inline-block;
  }
}
</style>
